import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/salario-base-de-cotizacion-variable-error';

/**
 * GET Historial de Errores del cálculo SBC Variable
 * @param {object} params ej. { salario_base_cotizacion_variable: id }
 * @returns {Promise<object[]>}
 */
export const getSBCVariableErrores = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data?.results || response.data || [];
  } catch (err) {
    onError(err);
  }
  return [];
};
